/* import __COLOCATED_TEMPLATE__ from './template-selector.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';
import { CUSTOM_TASK_TEMPLATES } from 'embercom/lib/operator/custom-bots/constants';
import type Template from 'embercom/models/template';

interface Args {
  templates: Template[];
  startFromScratchTemplate: Template;
  selectTemplate: any;
  onClose: () => void;
  createNewTask: () => void;
  recordAnalyticsEvent: any;
  transitionToPreview: any;
  showBackButton?: boolean;
  modal: any;
}

export default class TemplateSelector extends Component<Args> {
  get group() {
    return CUSTOM_TASK_TEMPLATES;
  }

  get templates() {
    return this.args.templates.filter((template) => template.objective === this.group.id);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Outbound::NewContentModal::TaskTemplate::TemplateSelector': typeof TemplateSelector;
    'outbound/new-content-modal/task-template/template-selector': typeof TemplateSelector;
  }
}
